(function () {
    angular.module('tmx-app').directive('tmxCheckbox', tmxCheckBox);
    /*
    https://github.com/danialfarid/ng-file-upload
    refer to above URL for documentation of the fileuploading library used	
    */
    function tmxCheckBox() {
        var directive = {};
        directive.scope = {
            name: '@',
            label: '@',
            value: '=',
            form: '=',
            required: '@',
            onChange: '&',
            dynamicField: '=',// only for dynamic form, ignore it and functions in which it occurs
            dynamicShow: '=',// only for dynamic form, ignore it and functions in which it occurs
            disabled: '=',
            applicationId: '=',
        };
        //directive.replace=true;
        directive.restrict = 'E';
        directive.templateUrl = 'common/directives/tmxcheckbox/tmxcheckbox.html';
        directive.controller = ["$scope", "tmxUtility", checkboxCtrl];
        directive.controllerAs = "checkboxCtrl";
        return directive;
    }
    function checkboxCtrl($scope, tmxUtility) {
        if (!angular.isDefined($scope.disabled)) {
            $scope.disabled = false;
        }
        var exists = tmxUtility.exists;
        var checkboxCtrl = this;
        checkboxCtrl.scope = $scope;
        if (!exists(checkboxCtrl.scope.value)) {
            checkboxCtrl.scope.value = 0;
        }
        else {
            try {
                checkboxCtrl.scope.value = Number(checkboxCtrl.scope.value);
            }
            catch(e) {
                checkboxCtrl.scope.value = 0;
            }
        }

        $scope.onchange = function () {
            checkboxCtrl.scope.onChange({ value: checkboxCtrl.scope.value, scope: checkboxCtrl.scope });
        }

    }


})();